import { CaseStatus } from '@/@types/generated'
import { register } from './enum'

export const CaseStatusTextColor: Record<CaseStatus, string> = {
  [CaseStatus.NEW]: 'text-blue-500',
  [CaseStatus.INV_ASSIGNED]: 'text-blue-500',
  [CaseStatus.INV_IN_REVIEW]: 'text-blue-500',
  [CaseStatus.ENF_ATTORNEY_REVIEW]: 'text-yellow-500',
  [CaseStatus.ENF_AFO_LTR_MAILED]: 'text-yellow-500',
  [CaseStatus.ENF_HEARING]: 'text-yellow-500',
  [CaseStatus.ENF_FO_LTR_MAILED]: 'text-yellow-500',
  [CaseStatus.ENF_NODD_LTR_MAILED]: 'text-yellow-500',
  [CaseStatus.ENF_MOTION_FOR_REHEARING]: 'text-yellow-500',
  [CaseStatus.ENF_COLLECTIONS]: 'text-yellow-500',
  [CaseStatus.ENF_FIRST_DEMAND_LTR_MAILED]: 'text-yellow-500',
  [CaseStatus.ENF_FINAL_DEMAND_LTR_MAILED]: 'text-yellow-500',
  [CaseStatus.ENF_RESPONSE_RECEIVED]: 'text-yellow-500',
  [CaseStatus.AV_NOI_NOTICE_OF_INTENT_MAILED]: 'text-yellow-500',
  [CaseStatus.AV_FD_FINAL_DETERMINATION_LTR_MAILED]: 'text-yellow-500',
  [CaseStatus.CCMPT_COMPTROLLER_REFERRAL]: 'text-purple-500',
  [CaseStatus.CCMPTAG_COMPTROLLER_AG_REFERRAL]: 'text-purple-500',
  [CaseStatus.CLOSED_AFTER_FINAL_ORDER]: 'text-purple-500',
  [CaseStatus.CLOSED_AFTER_HEARING_AND_FINAL_ORDER]: 'text-purple-500',
  [CaseStatus.CLOSED_AGREED_ORDER]: 'text-purple-500',
  [CaseStatus.CLOSED_CURED]: 'text-purple-500',
  [CaseStatus.CLOSED_DISMISSED]: 'text-purple-500',
  [CaseStatus.CLOSED_DUPLICATE_COMPLAINT]: 'text-purple-500',
  [CaseStatus.CLOSED_INSUFFICIENT_EVIDENCE]: 'text-purple-500',
  [CaseStatus.CLOSED_MEDIATED]: 'text-purple-500',
  [CaseStatus.CLOSED_NO_VIOLATION]: 'text-purple-500',
  [CaseStatus.CLOSED_NO_JURISDICTION]: 'text-purple-500',
  [CaseStatus.CLOSED_OUT_OF_BUSINESS]: 'text-purple-500',
  [CaseStatus.CLOSED_PAID_AFTER_NODD]: 'text-purple-500',
  [CaseStatus.CLOSED_REFERRAL_SENT]: 'text-purple-500',
  [CaseStatus.CLOSED_UNCOLLECTABLE]: 'text-purple-500',
  [CaseStatus.CLOSED_VOLUNTARY_SURRENDERED]: 'text-purple-500',
  [CaseStatus.CLOSED_WARNING]: 'text-purple-500',
}

export const CaseStatusLabels: Record<CaseStatus, string> = {
  [CaseStatus.NEW]: 'INV-New',
  [CaseStatus.INV_ASSIGNED]: 'INV-Assigned',
  [CaseStatus.INV_IN_REVIEW]: 'INV-In Review',
  [CaseStatus.ENF_ATTORNEY_REVIEW]: 'ENF-Attorney Review',
  [CaseStatus.ENF_AFO_LTR_MAILED]: 'ENF-AFO Ltr Mailed',
  [CaseStatus.ENF_HEARING]: 'ENF-Hearing',
  [CaseStatus.ENF_FO_LTR_MAILED]: 'ENF-FO Ltr Mailed',
  [CaseStatus.ENF_NODD_LTR_MAILED]: 'ENF-NODD Ltr Mailed',
  [CaseStatus.ENF_MOTION_FOR_REHEARING]: 'ENF-Motion for Rehearing',
  [CaseStatus.ENF_COLLECTIONS]: 'ENF-Collections',
  [CaseStatus.ENF_FIRST_DEMAND_LTR_MAILED]: 'ENF-First Demand Ltr Mailed',
  [CaseStatus.ENF_FINAL_DEMAND_LTR_MAILED]: 'ENF-Final Demand Ltr Mailed',
  [CaseStatus.ENF_RESPONSE_RECEIVED]: 'ENF-Response Received',
  [CaseStatus.AV_NOI_NOTICE_OF_INTENT_MAILED]: 'AV-NOI-Notice of Intent Mailed',
  [CaseStatus.AV_FD_FINAL_DETERMINATION_LTR_MAILED]:
    'AV-FD-Final Determination Letter Mailed',
  [CaseStatus.CLOSED_AFTER_FINAL_ORDER]: 'CAFO-Closed After Final Order',
  [CaseStatus.CLOSED_AFTER_HEARING_AND_FINAL_ORDER]:
    'CAHFO-Closed After Hearing and Final Order',
  [CaseStatus.CLOSED_AGREED_ORDER]: 'CAO-Closed Agreed Order',
  [CaseStatus.CLOSED_CURED]: 'CC-Closed Cured',
  [CaseStatus.CCMPT_COMPTROLLER_REFERRAL]: 'CCMPT-Comptroller Referral',
  [CaseStatus.CCMPTAG_COMPTROLLER_AG_REFERRAL]:
    'CCMPTAG-Comptroller AG Referral',
  [CaseStatus.CLOSED_DISMISSED]: 'CDIS-Closed Dismissed',
  [CaseStatus.CLOSED_DUPLICATE_COMPLAINT]: 'CDUP-Closed Duplicate Complaint',
  [CaseStatus.CLOSED_INSUFFICIENT_EVIDENCE]:
    'CIEVD-Closed Insufficient Evidence',
  [CaseStatus.CLOSED_MEDIATED]: 'CMED-Closed Mediated',
  [CaseStatus.CLOSED_NO_VIOLATION]: 'CN-Closed No Violation',
  [CaseStatus.CLOSED_NO_JURISDICTION]: 'CNJ-Closed No Jurisdiction',
  [CaseStatus.CLOSED_OUT_OF_BUSINESS]: 'COB-Closed Out of Business',
  [CaseStatus.CLOSED_PAID_AFTER_NODD]: 'CPAN-Closed Paid After NODD',
  [CaseStatus.CLOSED_REFERRAL_SENT]: 'CRS-Closed Referral Sent',
  [CaseStatus.CLOSED_UNCOLLECTABLE]: 'CU-Closed Uncollectable',
  [CaseStatus.CLOSED_VOLUNTARY_SURRENDERED]: 'CVS-Closed Voluntary Surrendered',
  [CaseStatus.CLOSED_WARNING]: 'CW-Closed Warning',
}

register<CaseStatus>(CaseStatus, (v) => {
  if (!v) return '\u2014'
  return CaseStatusLabels[v]
})
